export const SET_POLISHED_DIAMOND_GROUPS = 'SET_POLISHED_DIAMOND_GROUPS';
export const SET_POLISHED_DIAMOND_STATS = 'SET_POLISHED_DIAMOND_STATS';
export const ADD_FILTER = 'ADD_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const SET_POLISHED_CELL_ENTRIES = 'SET_POLISHED_CELL_ENTRIES';
export const SET_POLISHED_CELL_ENTRY = 'SET_POLISHED_CELL_ENTRY';
export const REMOVE_COLOR = 'REMOVE_COLOR';
export const ADD_COLOR = 'ADD_COLOR';
